export default "__VITE_ASSET__CASxvbAq__"